import React, { Component } from 'react'
import { Routes, Route } from 'react-router-dom'

import endPoints from '../../components/Consts/endPoints.json'

import { BeslenmeType, BeslenmeTypeForm } from '../../views/BeslenmeType'

export default class BeslenmeTypeRoute extends Component {
  render() {
    var releatedRoutes = endPoints.find(aa => aa.name == 'BeslenmeType')?.routes
    return (
      <Routes>
        <Route path={releatedRoutes?.get} exact element={<BeslenmeType />} />
        <Route path={releatedRoutes?.create} exact element={<BeslenmeTypeForm />} />
        <Route path={releatedRoutes?.update} exact element={<BeslenmeTypeForm />} />
      </Routes>
    )
  }
}
